export function footerFunc() {
  const footerAccordionBtn = $('#footer .accordionBtn');
  let resizecheck = $('#responsibleCheck').width();
  let resizecheck2 = 0;

  $(window).on('load resize', function () {
    resizecheck = $('#responsibleCheck').width();
    footerAccordionMenuStart();
  });
    
  //スマホ版ナビアコーディオン
  footerAccordionBtn.on('click', function () {
    if (resizecheck == '2') {
      if ($(this).hasClass('isOpen')) {
          $(this).next('dd').slideUp(500);
          $(this).removeClass('isOpen');
      } else {
          footerAccordionBtn.next('dd').slideUp(500);
          footerAccordionBtn.removeClass('isOpen');
          $(this).next('dd').slideDown(500);
          $(this).addClass('isOpen');
      }
    }
  }); 
  
    
  var footerAccordionMenuStart = function () {//アコーディオンの状態の初期化
      let resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '2' && resizecheck != resizecheck2) { //SPの時のみ
          footerAccordionBtn.next('dd').css('display', 'none');
          
          resizecheck2 = 2;
      } else if (resizecheck == '1' && resizecheck != resizecheck2) {
          footerAccordionBtn.removeClass('isOpen');
          footerAccordionBtn.next('dd').css('display', 'block');

          resizecheck2 = 1;
      }
  }
  footerAccordionMenuStart();
}